<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-text">消费总桌数：<span>{{statisticsInfo.count_all}}</span></div>
      <div class="v-text">消费总金额：<span>￥{{statisticsInfo.amout_all}}</span></div>
      <div class="v-text">本月桌数：<span>{{statisticsInfo.count_month}}</span></div>
      <div class="v-text">本月消费：<span>￥{{statisticsInfo.amout_month}}</span></div>
      <div class="v-text">今日桌数：<span>{{statisticsInfo.count_today}}</span></div>
      <div class="v-text">今日消费：<span>￥{{statisticsInfo.amout_today}}</span></div>
    </div>
    <div class="search-container">
      <div class="v-search-btn">
        <el-date-picker value-format="yyyy-MM-dd" class="v-date" v-model="valuedate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <el-input style="margin-left:16px;" v-model="valueid" clearable placeholder="请输入用户ID/手机号"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
      </div>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" width="250px" label="支付会员">
              <template slot-scope="scope">
                <div class="pay-member-photo">
                  <img :src="scope.row.member_wxheadurl" />
                </div>
                <div v-if="scope.row.name!==''" class="pay-member-name">{{ scope.row.member_name }}<br />ID：{{ scope.row.member_mid }}</div>
                <div v-else class="pay-member-name">{{ scope.row.member_wxname }}<br />ID：{{ scope.row.member_mid }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="原价">
              <template slot-scope="scope">
                <span>￥{{ scope.row.amount }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="实收">
              <template slot-scope="scope">
                <span>￥{{ scope.row.amount }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="付后余额">
              <template slot-scope="scope">
                <span>￥{{ scope.row.balance }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="结账方式">
              <template slot-scope="scope">
                <span>{{ spendtypeChange(scope.row.spendtype) }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="结账时间" width="160">
              <template slot-scope="scope">
                <span>{{ scope.row.createtime}} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="备注">
              <template slot-scope="scope">
                <span>{{ scope.row.remark}} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="200">
              <template slot-scope="scope">
                <el-button @click="handleEdit(scope.row.id,0)" type="success" size="mini">
                  <span>退款</span>
                </el-button>
                <el-button @click="handleEdit(scope.row.id,1)" type="warning" size="mini">
                  <span>补扣</span>
                </el-button>
                <el-button @click="handleChangeSpendShop(scope.row.id)" type="danger" size="mini">
                  <span>转移</span>
                </el-button>
                <el-button @click="handleRemark(scope.row)" type="primary" size="mini">
                  <span v-if="scope.row.remark===''">添加备注</span>
                  <span v-if="scope.row.remark!==''">修改备注</span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" :page-size="pageSize" layout="prev, pager, next" :current-page="page" :total="total">
      </el-pagination>
    </el-container>
    <el-dialog title="备注" :visible.sync="dialogVisible" width="30%" @close="handleClose">
      <el-input type="textarea" v-model="desc"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleAffirm">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import {
  searchSpendList,
  setSpendRemark,
  spendStatistics,
  modifySpend,
  changeSpendShop
} from '@/views/webpc/CashierDesk/CashRecordApp/apis'
export default {
  data () {
    return {
      isLoading: false,
      tableData: [],
      page: 1,
      pageSize: 20,
      total: 0,
      dialogVisible: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      valuedate: null,
      valueid: '',
      desc: '',
      params: {},
      statisticsInfo: {}
    }
  },
  methods: {
    // 结账方式
    spendtypeChange (status) {
      status = parseInt(status)
      switch (status) {
        case 0:
          return '个人余额'
        case 1:
          return '收银员扣款'
        default:
          return '其他'
      }
    },
    // 收银记录
    loadData () {
      this.isLoading = true
      this.tableData = []
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      data.append('keywords', this.valueid)
      if (this.valuedate) {
        data.append('startdate', this.valuedate[0])
        data.append('enddate', this.valuedate[1])
      }
      searchSpendList(data)
        .then((result) => {
          if (result) {
            this.isLoading = false
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        })
        .catch((error) => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    },
    handleClose () {
      this.params = {}
      this.desc = ''
      this.dialogVisible = false
    },
    handleRemark (params) {
      this.params = params
      this.desc = params.remark
      this.dialogVisible = true
    },
    handleAffirm () {
      let data = new FormData()
      data.append('id', this.params.id)
      data.append('remark', this.desc)
      setSpendRemark(data)
        .then((result) => {
          if (result) {
            this.dialogVisible = false
            this.loadData()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
        .catch((error) => {
          if (error) {
          }
        })
    },
    // 消费统计
    getSpendStatistics () {
      spendStatistics().then((result) => {
        if (result) {
          this.statisticsInfo = result.data
        }
      })
    },
    handleChangeSpendShop (id) {
      this.$confirm('确认转移, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.getChangeSpendShop(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    getChangeSpendShop (id) {
      let data = new FormData()
      data.append('id', id)
      changeSpendShop(data).then((result) => {
        if (result) {
          this.loadData()
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        }
      })
    },
    // 退款/补扣
    getMdifySpend (mid, type, amount) {
      let data = new FormData()
      data.append('id', mid)
      data.append('type', type)
      data.append('amount', amount)
      modifySpend(data).then((result) => {
        if (result) {
          this.loadData()
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        }
      })
    },
    handleEdit (mid, type) {
      let text = '退款金额'
      if (type === 1) {
        text = '补扣金额'
      }
      this.$prompt('请输入金额', text, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^([1-9]\d*(\.\d*)?)$|^0\.\d*[1-9]\d*$/,
        inputErrorMessage: '金额格式不正确'
      })
        .then(({ value }) => {
          this.getMdifySpend(mid, type, value)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    }
  },
  mounted () {
    this.getSpendStatistics()
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/CashRecordApp/CashRecord.vue